<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="cubes"/>
          {{ $t('translate') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="tab">
          <b-tab :title="$t('myCall')"></b-tab>
          <b-tab :title="$t('translateCall')"></b-tab>
          <b-tab :title="$t('report')"></b-tab>
          <b-tab :title="$t('history')"></b-tab>
        </b-tabs>
        <list v-if="tab === 0"  />
        <action v-else-if="tab === 1" />
        <report :user="$store.state.user" v-else-if="tab === 2" />
        <history :user="$store.state.user" v-else-if="tab === 3" />
      </div>
    </div>
  </main>
</template>
<script>

import Action from "./TranslateAction";
import List from "./TranslateList";
import Report from "./TranslateReport";
import History from "./History";

export default {
  components: {Action, List, Report, History},
  data: function () {
    return {
      tab: 0,
    }
  },
  i18n: {
    messages: {
      en: {
        translate: 'Biên dịch cuộc gọi',
        myCall: 'Các cuộc gọi đã biên dịch',
        translateCall: 'Biên dịch',
        report: 'Báo cáo',
        history: 'Lịch sử'
      },
      vi: {
        translate: 'Biên dịch cuộc gọi',
        myCall: 'Các cuộc gọi đã biên dịch',
        translateCall: 'Biên dịch',
        report: 'Báo cáo',
        history: 'Lịch sử'
      }
    }
  },
  methods: {
  }
}
</script>